module.exports = __webpack_public_path__ + "img/99.37114e3.png";